
import React from "react";
/* import Navbar from "../components/layout/Navbar"; */
/* import Footer from "../components/layout/Footer"; */
import "../App.css";
import eduBanner from "../assets/img/edu_banner.jpg";

function Tooltip({ text, children }) {
  const [visible, setVisible] = React.useState(false);

  return (
    <span
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span style={{
          position: "absolute",
          bottom: "125%",
          left: "0",
          backgroundColor: "#ffffff",
          color: "#761bec",
          padding: "8px 12px",
          borderRadius: "6px",
          width: "400px",
          fontSize: "0.8rem",
          zIndex: 100,
          boxShadow: "0 2px 8px rgba(57, 21, 238, 0.3)"
        }}>
          {text}
        </span>
      )}
    </span>
  );
}

export default function Education() {
  return (
    <>

      <header
        className="education-banner text-white"
        style={{ backgroundImage: `url(${eduBanner})` }}
        >
        <div className="container text-center">
          <h1 className="fw-bold">Education</h1>
          <p className="lead mt-3">
            An introductory guide to cryptocurrency, digital assets, and more.
          </p>
        </div>
      </header>

      <main className="py-5">
        <div className="container">
          <section className="mb-5">
            <p>
              This page is designed to help newcomers understand the basics of
              cryptocurrency and digital ownership before exploring our
              designs. There are many pieces to cryptocurrency, so the goal
              here is to break them down in a clear and approachable way.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">What is Cryptocurrency?</h2>
            <p>
              Cryptocurrency is a digital form of decentralized currency that
              is used to buy, sell, and transfer value of both digital and
              physical goods and services. It operates on a technology called
              blockchain, which is a distributed ledger that records all
              transactions across a network of computers. This means that
              cryptocurrency is not controlled by any single entity, such as a
              government or bank, making it resistant to censorship and
              interference.
            </p>
            <p>
              Cryptocurrency as we now know it first started being utilized in
              the late 2000s. "Decentralized" means that these currencies are
              not issued or controlled by governments or traditional financial
              institutions. This lack of central control is one of the main
              reasons cryptocurrency is appealing to many people. There are
              many different types of cryptocurrencies, including Bitcoin
              (BTC), Litecoin (LTC), Ethereum (ETH), Solana, and even
              meme-based coins like Dogecoin.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">What is Bitcoin?</h2>
            <p>
              Bitcoin was the first form of cryptocurrency to be created, and
              it has remained the most popular and widely recognized since.
            </p>
            <p>
              There are several reasons why Bitcoin has maintained its
              popularity. One major factor is that it was the first of its
              kind and continues to dominate the digital currency market.
              Unlike many other cryptocurrencies, Bitcoin is accepted by some
              restaurants, online retailers, and even travel agencies as a
              form of payment.
            </p>
            <p>
              Bitcoin is also valued for its scarcity. While it may seem
              strange for something digital to be considered “rare,” Bitcoin
              was designed with a strict limit. There will only ever be 21
              million bitcoins in existence. This limited supply contributes
              to its perceived value, much like how gold is valued due to its
              rarity.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">What is a Digital Wallet?</h2>
            <p>
              A digital wallet is a tool that allows users to store, send, and
              receive cryptocurrency securely.
            </p>
            <p>
              Digital wallets do not store physical money. Instead, they
              store the private keys that prove ownership of digital assets on
              the blockchain. Wallets can come in many forms, including
              mobile apps, browser extensions, desktop software, or even
              physical hardware devices. While wallets provide users with
              full control over their assets, this also means the
              responsibility of keeping them secure lies entirely with the
              user.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">What is an NFT?</h2>
            <p>
              An NFT, or Non-Fungible Token, is a type of digital asset that
              represents ownership of a unique item.
            </p>
            <p>
              Unlike cryptocurrencies such as Bitcoin, which are
              interchangeable, NFTs are one-of-a-kind. They are often used to
              represent digital art, music, videos, or other creative works.
              NFTs are stored on a blockchain, which allows ownership and
              authenticity to be verified. While NFTs are commonly associated
              with art and collectibles, the technology behind them can be
              applied to many other industries as well.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">Understanding the Risks</h2>

            <p>
              While cryptocurrency and digital assets offer new opportunities,
              they also come with significant risks. One of the most important
              things to understand is that users are fully responsible for
              their own security.
            </p>

            <p>
              If you lose access to your digital wallet — such as forgetting
              your password or losing your private key or recovery phrase —
              there is typically no way to recover your funds. Unlike
              traditional banks, there is no customer service department that
              can reset your account. Lost credentials can mean permanently
              lost assets.
            </p>

            <p>
              Cryptocurrency markets are also highly volatile. Prices can
              fluctuate dramatically within minutes or hours due to market
              demand, news events, regulation changes, or investor behavior.
              This means the value of digital assets can rise quickly, but it
              can also fall just as rapidly.
            </p>

            <p>
              Additionally, because the industry is still evolving, users may
              encounter scams, phishing attempts, fraudulent projects, or
              misleading investment opportunities. It is essential to verify
              sources, use secure platforms, and conduct thorough research
              before making financial decisions.
            </p>

            <p>
              As with any investment or emerging technology, individuals
              should only invest what they are willing to lose and take time
              to understand the risks involved.
            </p>
          </section>

          <section className="mb-5">
            <h2 className="fw-semibold">Learn More</h2>
            <ul>
              <li>
                <Tooltip text="Cryptocurrency is explained as a digital asset that operates on decentralized, 
                encrypted networks rather than through governments or banks, with all transactions recorded on a public blockchain ledger. 
                The article emphasizes that while crypto is often described as “digital money,” it isn’t widely accepted as everyday payment, and most people 
                buy it instead as an alternative investment or as a way to support blockchain technology. It breaks down how blockchain works—using distributed verification across thousands of computers to make transactions secure, immutable, and resistant to tampering—and why this technology is considered a major disruptor with applications in areas like payments, contracts, health records, real estate, and supply chains."> 
                <a
                  href="https://www.britannica.com/money/what-is-cryptocurrency"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Britannica — What is Cryptocurrency?
                </a> </Tooltip>
              </li>
              <li>
                <Tooltip text="Forbes goes over the origins of Bitcoin, explaining how it emerged in 2008 when an 
                unknown creator using the pseudonym Satoshi Nakamoto published the Bitcoin white paper outlining a decentralized, peer‑to‑peer digital currency. 
                It highlights the mystery surrounding Nakamoto’s identity—whether an individual or a group—and notes key early milestones, such as the mining of the first block (the “genesis block”) in 2009 and the handoff of project control to the open‑source community.">
                <a
                  href="https://www.forbes.com/sites/digital-assets/article/the-history-of-bitcoin-who-invented-it/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Forbes — The History of Bitcoin
                </a> </Tooltip>
              </li>
              <li>
                <Tooltip text="This guide explains the wide range of things people can now buy with Bitcoin, including everyday essentials to major luxury purchases. While most retailers still don’t accept Bitcoin directly, the article highlights practical workarounds like using BitPay or Bitrefill gift cards to shop at grocery stores, clothing retailers, and online marketplaces. Travel is one of the most crypto‑friendly sectors, with options to book flights, hotels, and events using Bitcoin or gift cards.">
                <a
                  href="https://hermesbitcoin.com/what-you-can-buy-with-bitcoin/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Hermes Bitcoin — What You Can Buy with Bitcoin
                </a> </Tooltip>
              </li>
            </ul>
          </section>
        </div>
      </main>

      <footer className="py-4 bg-light">
        <div className="container text-center">
          <small>© 2026 Equivalents. All rights reserved.</small>
        </div>
      </footer>
    </>
  );
}